import { Banks } from '@/firebase/index';

export default {
  getAllBanks() {
    return Banks.get();
  }
};
